export default __webpack_public_path__ + "static/media/Veronica_Segrera_AHV_In_Moms_We_Trust.2c4b59b2.jpg";